import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 5v6a3 3 0 0 0 3 3h7","key":"svg-0"}],["path",{"d":"M10 10l4 4l-4 4m5 -8l4 4l-4 4","key":"svg-1"}]]

const IconCornerDownRightDouble = createReactComponent('outline', 'corner-down-right-double', 'CornerDownRightDouble', __iconNode);

export default IconCornerDownRightDouble;